import React from 'react';
export function StatsBar() {
  return <div className="bg-ocean-teal-dark text-white py-6 border-y border-ocean-teal/30" data-id="element-245">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-246">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center divide-x divide-white/10" data-id="element-247">
          <div className="px-2" data-id="element-248">
            <div className="text-2xl md:text-3xl font-bold mb-1" data-id="element-249">+2.000</div>
            <div className="text-xs md:text-sm text-ocean-teal-light" data-id="element-250">
              profesionales confían
            </div>
          </div>
          <div className="px-2" data-id="element-251">
            <div className="text-2xl md:text-3xl font-bold mb-1" data-id="element-252">12</div>
            <div className="text-xs md:text-sm text-ocean-teal-light" data-id="element-253">
              Recursos listos
            </div>
          </div>
          <div className="px-2" data-id="element-254">
            <div className="text-2xl md:text-3xl font-bold mb-1" data-id="element-255">4.9/5</div>
            <div className="text-xs md:text-sm text-ocean-teal-light" data-id="element-256">
              calificación ⭐
            </div>
          </div>
          <div className="px-2" data-id="element-257">
            <div className="text-2xl md:text-3xl font-bold mb-1" data-id="element-258">100%</div>
            <div className="text-xs md:text-sm text-ocean-teal-light" data-id="element-259">
              Para manicuristas
            </div>
          </div>
        </div>
      </div>
    </div>;
}